import { useRef, useMemo, useEffect } from 'react';

export const useDebounce = (delay: number) => {
	const timeout = useRef<number>();
	const debounce = useMemo(() => {
		const debounce = (callback: () => void) => {
			clearTimeout(timeout.current);
			timeout.current = window.setTimeout(callback, delay);
		};
		return debounce;
	}, [delay]);
	useEffect(() => () => clearTimeout(timeout.current), []);
	return debounce;
};
